import { buildTableOptions } from '../buildTableOptions';
import {
  BuildTableModelsSectionsArgs,
  BuildTableModelsSectionsReturn,
} from './model';

export const buildTableModelsSections = ({
  connector,
  preconfiguredModels,
  destinationName,
}: BuildTableModelsSectionsArgs): BuildTableModelsSectionsReturn[] => {
  const modelSections: BuildTableModelsSectionsReturn[] = [];
  connector.sources?.forEach((source) => {
    connector.models?.forEach((model) => {
      const belongsToDestination = connector.destinations.some(
        (destination) => destination.name === destinationName
      );

      if (!belongsToDestination) {
        return;
      }

      const preconfiguredModel = preconfiguredModels.find(
        (localModel) => localModel.name === model.preconfiguredModelRef
      );

      if (!preconfiguredModel) {
        return;
      }

      const egressedTables = model.egressedTables.find(
        (egressedTables) =>
          egressedTables.revisionNumber === Number(model.revision)
      );

      if (!egressedTables) {
        return;
      }

      const { options, checkboxForm } = buildTableOptions({
        preconfiguredModel,
        chosenTables: egressedTables.tables,
      });

      const selectedAll = options.every((option) => checkboxForm[option]);

      const data = {
        sourceDisplayName: source.displayName,
        modelDisplayName: model.displayName,
        modelName: model.name,
        modelStableVersion: preconfiguredModel.stableVersion,
        selectedAll,
        options,
        checkboxForm,
      };

      modelSections.push(data);
    });
  });

  return modelSections || [];
};
